var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductSetup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
    fill: "#5062F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6667 11C19.4638 11 19.2638 11.0845 19.1123 11.2438L11.5664 19.177L11.1793 20.8045L12.68 20.41L20.2211 12.482C20.2963 12.4029 20.3572 12.3077 20.3992 12.2012C20.4411 12.0946 20.463 11.9796 20.463 11.8629C20.463 11.7462 20.4411 11.6312 20.3992 11.5246C20.3572 11.4181 20.2963 11.3229 20.2211 11.2438C20.1459 11.1648 20.058 11.1035 19.9631 11.0622C19.8683 11.0209 19.7677 11 19.6667 11ZM18.3877 10.5546C18.7225 10.2027 19.1819 10 19.6667 10C19.9062 10 20.1426 10.0496 20.3624 10.1453C20.5821 10.241 20.78 10.3805 20.9456 10.5546C21.1112 10.7286 21.2412 10.9339 21.3296 11.1581C21.4179 11.3822 21.463 11.6216 21.463 11.8629C21.463 12.1042 21.4179 12.3436 21.3296 12.5677C21.2412 12.7919 21.1112 12.9972 20.9456 13.1712L13.3067 21.2021C13.2428 21.2694 13.1613 21.3175 13.0716 21.3411L10.6271 21.9836C10.4572 22.0282 10.2763 21.9804 10.1506 21.8577C10.025 21.7349 9.97293 21.5552 10.0136 21.3843L10.6247 18.8144C10.6451 18.7285 10.688 18.6495 10.7488 18.5855L18.3877 10.5546ZM15.5 21.5C15.5 21.2239 15.7239 21 16 21H21.5C21.7762 21 22 21.2239 22 21.5C22 21.7761 21.7762 22 21.5 22H16C15.7239 22 15.5 21.7761 15.5 21.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductSetup);
export default __webpack_public_path__ + "static/media/productSetup.807c2786cb7ee265ebe11ffaa64d5f05.svg";
export { ForwardRef as ReactComponent };